import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BreadcrumbData } from "use-react-router-breadcrumbs";
import Link, { LinkProps } from "@mui/material/Link";

import { BreadCrumbSeparatorIcon } from "@/assets/icons";
import { useRouterHook } from "@/shared/hooks";

interface BreadcrumbItemProps {
    breadcrumbData: BreadcrumbData;
    title: string;
    isLastItem: boolean;
}

export const BreadcrumbItem: FC<BreadcrumbItemProps> = ({ breadcrumbData, title, isLastItem }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { match, breadcrumb } = breadcrumbData;

    const { pathname, state } = useRouterHook();
    let breadcrumbComponent = typeof match?.route?.breadcrumb === "string" ? t(match.route.breadcrumb) : breadcrumb;

    breadcrumbComponent = match?.route?.breadcrumb ? breadcrumbComponent : title;
    const linkAdditionalProps: LinkProps = isLastItem ? { "aria-current": "page" } : {};
    return (
        <div className="bc">
            <Link
                onClick={() => {
                    return pathname !== match.pathname ? navigate(match.pathname, { state }) : {};
                }}
                data-testid={`breadcrumbs-link-${match.pathname.split("/").pop() || "home"}`}
                className="breadcrumbsName"
                {...linkAdditionalProps}
            >
                {breadcrumbComponent}
            </Link>
            {!isLastItem && <BreadCrumbSeparatorIcon className="breadcrumbRafter" />}
        </div>
    );
};

export default BreadcrumbItem;
